import { logError } from 'lib/sentry/logError';

import { ChallengeTimelineItemType } from 'features/challenge/ChallengeTimelineItem';
import { CHALLENGE_LOCATIONS } from 'features/challenge/config';
import { useAddCustomChallenge } from 'features/challenge/hooks/useAddCustomChallenge';
import {
  usePlanningAnalyticsEvents,
  usePlanningBacklogQueryActions,
} from 'features/planning';

import { showErrorToast } from 'shared/components/Toast';

export const useAddBacklogChallenge = () => {
  const { sendPlanningChallengeAddedEvent } = usePlanningAnalyticsEvents();
  const {
    invalidateBacklogQuery,
    updateBacklog,
    getBacklog,
    cancelBacklogQueries,
  } = usePlanningBacklogQueryActions();

  const openAddChallengeModal =
    useAddCustomChallenge<ChallengeTimelineItemType>({
      //@ts-ignore
      sprint: null,
      options: {
        //@ts-ignore
        onMutate: async ({ challenges: challenge }) => {
          await cancelBacklogQueries();

          const previousBacklogValue = getBacklog();

          //@ts-ignore
          updateBacklog([...previousBacklogValue!.items, challenge]);

          return { challenges: previousBacklogValue?.items ?? [] };
        },
        onSuccess: async () => {
          sendPlanningChallengeAddedEvent(CHALLENGE_LOCATIONS.BACKLOG);
          invalidateBacklogQuery();
        },
        onError: async (
          error,
          __,
          context: { challenges: ChallengeTimelineItemType[] } | undefined
        ) => {
          if (!context?.challenges) {
            return;
          }
          //@ts-ignore
          updateBacklog(context.challenges);

          logError(error);
          showErrorToast('Failed to add challenge to backlog');
        },
      },
      parameters: { addToBacklog: true },
    });

  return openAddChallengeModal;
};
